import { gql, TypedDocumentNode } from '@apollo/client'
import { QueryPageableRequest, QueryPageableResponse } from '../../../core/type'
import {
  ItemBulkUpdateHistory,
  ItemBulkUpdateHistoryItem,
  ItemBulkUpdateHistoryRequest
} from '../type/item-bulk-update-history'

export const ItemBulkHistoryQuery: TypedDocumentNode<QueryPageableResponse<ItemBulkUpdateHistory, 'itemBulkUpdateHistoryFind'>, QueryPageableRequest<ItemBulkUpdateHistoryRequest>> = gql`
    query ItemBulkHistoryQuery($request: ItemBulkHistoryRequest!) {
        itemBulkUpdateHistoryFind(request: $request) {
            data {
                id
                createdAt
            }
            count
        }
    }
`

export const ItemBulkHistoryItemQuery: TypedDocumentNode<QueryPageableResponse<ItemBulkUpdateHistoryItem, 'itemBulkUpdateHistoryItemFind'>, QueryPageableRequest<{
  historyId: number
  itemId?: number
}>> = gql`
    query ItemBulkHistoryItemQuery($request: ItemBulkHistoryItemRequest!) {
        itemBulkUpdateHistoryItemFind(request: $request) {
            data {
                item {
                    sku
                }
                changes
            }
            count
        }
    }
`